import React from 'react'
import format from 'date-fns/format'

import {
    StyledTimestamp,
    ClockIcon,
    ClockIconAlt,
} from 'component-library/typography/Timestamp/Timestamp.styled'
import { ThemedRender } from 'component-library/__styling/themed-render'
import { getTimeAgo } from 'common/helpers/time'
import { useProduct } from "common/hooks/useProduct"

const componentTheme = {
    sevennews: {
        timestamp: {
            dateOnly: 'dddd, D MMMM YYYY',
            dateTime: 'dddd, D MMMM YYYY h:mm a',
        },
    },
    thewest: {
        timestamp: {
            dateOnly: 'dddd, D MMMM YYYY',
            dateTime: 'dddd, D MMMM YYYY h:mmA',
        },
    },
    perthnow: {
        timestamp: {
            dateOnly: 'MMMM D, YYYY',
            dateTime: 'MMMM D, YYYY h:mmA',
        },
    },
}

export interface TimestampProps {
    timestamp: string | number
    iconVisible?: boolean
    dateOnly?: boolean
    relative?: boolean
    className?: string
}

export const Timestamp: React.FC<TimestampProps> = ({
    timestamp,
    iconVisible,
    dateOnly,
    className,
    relative,
}) => {
    const product = useProduct()

    if (!timestamp) {
        return null
    }
    const themeValues = componentTheme[product].timestamp

    const humanReadableTimestamp = relative
        ? getTimeAgo(String(timestamp))
        : dateOnly
        ? format(timestamp, themeValues.dateOnly)
        : format(timestamp, themeValues.dateTime)

    const html5datetime = format(timestamp, 'YYYY-MM-DDTHH:mmZ')

    const Icon = <ThemedRender thewest={() => <ClockIcon />} sevennews={() => <ClockIconAlt />} />

    return (
        <StyledTimestamp
            dateTime={html5datetime}
            className={className}
            suppressHydrationWarning={true}
        >
            {iconVisible && Icon}
            {humanReadableTimestamp}
        </StyledTimestamp>
    )
}
Timestamp.displayName = 'Timestamp'
